if(!customElements.get('accordion-group')) {
  class AccordionGroup extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const clickedDetails = e.target.closest('details');
        
        if (!clickedDetails || clickedDetails.open) return;

        const allDetails = this.querySelectorAll(`details[open]`);
        
        allDetails.forEach((el) => {
          if (el !== clickedDetails) el.removeAttribute('open');
        });
        setTimeout(() => {
          clickedDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
    }
  }

  customElements.define('accordion-group', AccordionGroup);
}